import { render, staticRenderFns } from "./group_setting.vue?vue&type=template&id=31f44556&scoped=true"
import script from "./group_setting.vue?vue&type=script&lang=ts"
export * from "./group_setting.vue?vue&type=script&lang=ts"
import style0 from "./group_setting.vue?vue&type=style&index=0&id=31f44556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f44556",
  null
  
)

export default component.exports